/**
 * Shared copy + detection for the draft-gone race: a clinical draft (SDI/RDI/
 * Dx) can vanish while an editor still holds its id - submit in another tab
 * promotes the draft event in-place, or a teammate discards it - after which
 * every update PUT 404s. Both draft lifecycles use these to disarm gracefully.
 *
 * Lives in its own module (not clinicalDrafts.ts) so the draft lifecycle hooks
 * don't pull the axios client in transitively just for a constant.
 */
export const DRAFT_GONE_MESSAGE =
    'This draft was submitted or discarded in another tab or by a teammate. Auto-save is paused - Save draft will continue your work as a fresh copy.';

export function isDraftGone404(err: unknown): boolean {
    const e = err as { isAxiosError?: boolean; response?: { status?: number } } | null;
    // Require the axios marker: a bare 404-shaped object (deploy-skew, route
    // regressions surfacing differently) must not be reported to the clinician
    // as a claim about a teammate's actions.
    return e?.isAxiosError === true && e.response?.status === 404;
}
